import { graphql, ResultOf } from "conversion_flows/lib/graphql"

export const GET_PRICE_RATINGS_FOR_WIDGET = graphql(`
  query PriceRatings($customerId: ID!, $urls: [String!]!) {
    priceRatings(customerId: $customerId, urls: $urls) {
      car {
        id
        auRating
        auCarUrl(customerId: $customerId)
        ratingText
      }
      customerCarUrl
    }
  }
`)

export type GetPriceRatingsForWidgetResult = ResultOf<
  typeof GET_PRICE_RATINGS_FOR_WIDGET
>

export type PriceRatingCar =
  GetPriceRatingsForWidgetResult["priceRatings"][number]["car"]
